export const HIERARCHY_BLOCK_HEIGHT = 500
export const HIERARCHY_PARENT_NODE_CLASS = 'hierarchy-parent-node'
export const HIERARCHY_ROOT_NODE_CLASS = 'hierarchy-root-node'
export const SCROLL_TOP_GAP = 10
export const SCROLL_OFFSET = 20
export const MAX_LEVEL_HIERARCHY = 5
